(function () {
  var STORAGE_KEY = 'pbTrail';

  function getTrail() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch (error) {
      return {};
    }
  }

  function setTrail(data) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {}
  }

  function getRefPath() {
    try {
      if (!document.referrer) return '';

      var ref = new URL(document.referrer);

      if (ref.origin !== window.location.origin) return '';

      return ref.pathname;
    } catch (error) {
      return '';
    }
  }

  function initPartnerBrandsNavigation(root) {
    if (!root || root.dataset.partnerBrandsNavigationReady === 'true') return;

    root.dataset.partnerBrandsNavigationReady = 'true';

    var context = root.dataset.context || '';
    var partnerUrl = root.dataset.partnerUrl || '/pages/brands';
    var partnerTitle = root.dataset.partnerTitle || 'Partner Brands';
    var currentTitle = root.dataset.currentTitle || '';
    var currentPath = root.dataset.currentPath || window.location.pathname;
    var productsLabel = root.dataset.productsLabel || 'Products';

    function showCrumb(name) {
      var el = root.querySelector('[data-crumb="' + name + '"]');

      if (el) {
        el.classList.remove('is-hidden');
      }

      return el;
    }

    function hideCrumb(name) {
      var el = root.querySelector('[data-crumb="' + name + '"]');

      if (el) {
        el.classList.add('is-hidden');
      }

      return el;
    }

    function setCrumbAsLink(name, text, href) {
      var el = showCrumb(name);
      if (!el) return;

      var a = el.querySelector('a');
      var span = el.querySelector('span');

      if (a) {
        a.textContent = text;
        a.href = href;
        a.classList.remove('is-hidden');
      }

      if (span) {
        span.classList.add('is-hidden');
      }

      el.removeAttribute('aria-current');
    }

    function setCrumbAsCurrent(name, text) {
      var el = showCrumb(name);
      if (!el) return;

      var a = el.querySelector('a');
      var span = el.querySelector('span');

      if (a) {
        a.classList.add('is-hidden');
      }

      if (span) {
        span.textContent = text;
        span.classList.remove('is-hidden');
      }

      el.setAttribute('aria-current', 'page');
    }

    var refPath = getRefPath();
    var trail = getTrail();

    if (!trail || typeof trail !== 'object') {
      trail = {};
    }

    if (context === 'page') {
      trail.fromPartner = refPath === partnerUrl || trail.fromPartner === true;
      trail.vendorUrl = currentPath;
      trail.vendorTitle = currentTitle;
      trail.collectionUrl = '';
      trail.collectionTitle = '';

      setTrail(trail);
    }

    if (context === 'collection') {
      if (refPath === partnerUrl) {
        trail.fromPartner = true;
        trail.vendorUrl = '';
        trail.vendorTitle = '';
      } else if (trail.vendorUrl && refPath === trail.vendorUrl) {
        trail.fromPartner = trail.fromPartner === true;
      }

      trail.collectionUrl = currentPath;
      trail.collectionTitle = productsLabel;

      setTrail(trail);
    }

    if (context === 'product') {
      setTrail(trail);
    }

    if (trail.fromPartner) {
      showCrumb('partner');
    } else {
      hideCrumb('partner');
    }

    hideCrumb('vendor');

    if (context === 'page') {
      setCrumbAsCurrent('vendor', currentTitle);
    }

    if (context === 'collection') {
      if (trail.vendorUrl && trail.vendorTitle) {
        setCrumbAsLink('vendor', trail.vendorTitle, trail.vendorUrl);
      } else {
        hideCrumb('vendor');
      }

      setCrumbAsCurrent('products', trail.collectionTitle || productsLabel);
    }

    if (context === 'product') {
      if (trail.vendorUrl && trail.vendorTitle) {
        setCrumbAsLink('vendor', trail.vendorTitle, trail.vendorUrl);
      } else {
        hideCrumb('vendor');
      }

      if (trail.collectionUrl) {
        setCrumbAsLink('products', trail.collectionTitle || productsLabel, trail.collectionUrl);
      } else {
        setCrumbAsCurrent('products', trail.collectionTitle || productsLabel);
      }
    }

    var backText = root.querySelector('.partner-brands-nav__back-text');

    if (backText) {
      backText.textContent = trail.fromPartner
        ? 'Back to ' + partnerTitle
        : 'View all ' + partnerTitle;
    }
  }

  function initAllPartnerBrandsNavigation(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-partner-brands-navigation]');

    sections.forEach(function (section) {
      initPartnerBrandsNavigation(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllPartnerBrandsNavigation(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllPartnerBrandsNavigation(event.target);
  });
})();